<template>
   <v-container class="d-flex align-center justify-center">
     <v-card max-width="1000px" class="pa-5 d-flex flex-column align-center">
        <h2 class="text-center indigo--text font-weight-bold">Create an account</h2>
        <div class="text-center">
                  <span>Already have an account?</span>
                  <v-btn text color="indigo" class="ml-n3" to="/login">Login</v-btn>
                </div>
        <v-card-text>
            <div>
              <v-form ref="loginForm" v-model="validLoginForm">
                <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                  v-model="fullName"
                  label="Full Name"
                  outlined
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                >
                <template v-slot:label>
                    Full  Name <span class="red--text">*</span>
                </template>
              </v-text-field>
                </v-col>
                 <v-col cols="12" md="6">
                <v-text-field
                  v-model="email"
                  label="Email"
                  outlined
                  clearable
                  color="indigo"
                  :rules="[rules.required, rules.email]"
                >
                  <template v-slot:label>
                    Email <span class="red--text">*</span>
                </template>
              </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                <v-text-field
                  v-model="password"
                  outlined
                  label="Password"
                  color="indigo"
                  :rules="[rules.required]"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                >
                  <template v-slot:label>
                    Password <span class="red--text">*</span>
                </template>
              </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                <phoneInput @update="assignPhone" class="mb-4" />
                </v-col>
                <v-col cols="12" md="6">
                <v-text-field
                  v-model="agency_details.agency_name"
                  outlined
                  label="Agency Name"
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                >
                   <template v-slot:label>
                    Agency Name <span class="red--text">*</span>
                </template>
              </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="gdsNumber"
                  outlined
                  label="GDS System"
                  clearable
                  @click:clear="gdsNumber = []"
                  multiple
                  :items="['sabre','amadeus','travelport']"
                  color="indigo"
                >
              </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                <v-text-field
                  v-model="agency_details.iata_number"
                  label="Iata Number"
                  outlined
                  clearable
                  color="indigo"
                />
                </v-col>
                 <!-- <v-autocomplete
                  v-model="agency_details.office_id"
                  label="Office"
                  outlined
                  :items="offices"
                  item-value="id"
                  item-text="name"
                /> -->
                <v-col cols="12" md="6">
                <v-text-field
                  v-model="agency_details.ein"
                  label="Ein"
                  outlined
                  clearable
                  color="indigo"
                />
                </v-col>
                <v-col cols="12" md="6">
                <v-text-field
                  v-model="agency_details.avg_sales"
                  label="Avrage Sales"
                  outlined
                  type="number"
                  clearable
                  color="indigo"
                />
                </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field
                  v-model="agency_details.address"
                  outlined
                  label="Address"
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                >
                  <template v-slot:label>
                    Address <span class="red--text">*</span>
                </template>
              </v-text-field>
                 </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field
                  v-model="agency_details.city"
                  outlined
                  clearable
                  label="City"
                  color="indigo"
                  :rules="[rules.required]"
                >
                   <template v-slot:label>
                    City <span class="red--text">*</span>
                </template>
                </v-text-field>
                 </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field
                  v-model="agency_details.state"
                  outlined
                  label="State"
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                >
                   <template v-slot:label>
                    state <span class="red--text">*</span>
                </template>
              </v-text-field>
                 </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field
                  v-model="agency_details.zipCode"
                  outlined
                  label="Zip Code"
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                >
                   <template v-slot:label>
                    Zip Code <span class="red--text">*</span>
                </template>
              </v-text-field>
                 </v-col>
                 <v-col cols="12" md="6">
                  <v-autocomplete
                  :items="countries"
                  v-model="agency_details.country"
                  item-text="name"
                  label="Country"
                  item-value="code"
                  outlined
                  clearable
                  color="indigo"
                  :rules="[rules.required]"
                >
                 <template v-slot:label>
                    Country <span class="red--text">*</span>
                </template>
              </v-autocomplete>
                 </v-col>
                <v-btn block color="indigo" class="white--text rounded-xl" @click="login" :loading="loading">SignUp</v-btn>
                </v-row>
            </v-form>
          </div>
        </v-card-text>
     </v-card>
   </v-container>
</template>
<script>
import { headersNoAuth, register } from '.././links'
import phoneInput from '../components/mobile.vue'
import { countries } from '../contants.js'
export default {
  components: {
    phoneInput
  },
  data () {
    return {
      validLoginForm: true,
      validResetForm: true,
      validResetCodeForm: true,
      loading: false,
      email: null,
      gdsNumber: [],
      // internalDomains: ['adamtravel.com', 'adamtravel.net', 'atsfares.com'],
      agency_details: {
        agency_name: null,
        gds_number: null,
        registration_type: 'airfares',
        // office_id: null,
        iata_number: null,
        ein: null,
        avg_sales: null,
        country: null,
        state: null,
        zipCode: null,
        city: null,
        address: null
      },
      fullName: null,
      phone: null,
      countryIsoCode: null,
      text: null,
      color: null,
      show: false,
      address: null,
      password: null,
      rules: {
        required: value => !!value || 'this field is required',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail'
        }
      }
    }
  },
  computed: {
    countries () {
      return countries
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate()
      if (this.validLoginForm) {
        this.loading = true
        if (this.gdsNumber && !this.gdsNumber.length) this.agency_details.gds_number = null
        else if (this.gdsNumber && this.gdsNumber.length) this.agency_details.gds_number = this.gdsNumber.join(',')
        const agentBody = {
          name: this.fullName,
          password: this.password,
          email: this.email,
          phone: this.phone,
          phone_country: this.countryIsoCode,
          agency_details: this.agency_details
        }
        const header = { headers: headersNoAuth() }

        this.$http.post(register, agentBody, header)
          .then(response => {
            if (response.data.data) {
              this.$store.commit('showFeedback', { text: response.data.message, color: response.data.ok ? 'success' : 'error' })
              if (!response.data.data.user.requires_approval) {
                console.log('test')
                this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
                this.$store.commit('setUserId', response.data.data.user.id)
                this.$store.commit('setUser', response.data.data.token.access_token)
                localStorage.setItem('BVtoken', response.data.data.token.access_token)
                this.$store.commit('setUserData', response.data.data.user)
                this.$router.push('/')
              } else {
                this.$router.push('/confirm')
                this.$store.commit('showFeedback', { text: ' once you get a verification email u can login and book ticket', color: 'success' })
              }
              // this.$store.commit('setEmail', this.email)
              // this.$router.push('/verify')
              // localStorage.setItem('token', response.data.data.token.access_token)
            } else {
              this.$store.commit('showFeedback', { text: response.data.message, color: 'error' })
            }
          }).catch(error => {
            this.$store.commit('showFeedback', {
              text: error.body?.message || 'Something went wrong.',
              color: 'error'
            })
          }).finally(() => {
            this.loading = false
          })
      }
    },
    assignPhone (phone) {
      console.log(phone)
      this.countryIsoCode = phone.countryCode
      this.phone = phone.number
    }

  }
}
</script>
